module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_008.png
// module id = 2355
// module chunks = 5